import {
  TextAppearance,
  TextColor,
  TextCustom,
  TextCustomProps,
  TextLineHeight,
  TextSize,
  TextTag,
  TextWeight,
} from '@vw-marketing/us-components';
import React from 'react';

export const sectionTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize16,
    lineHeight: TextLineHeight.TextLineHeight24,
    fontWeight: TextWeight.bold,
    color: TextColor.primary,
  },
};

export const distanceLabelMilesTextStyle: TextCustomProps = {
  appearance: TextAppearance.headline200,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize16,
    lineHeight: TextLineHeight.TextLineHeight36,
    fontWeight: TextWeight.regular,
    color: TextColor.inherit,
  },
};

export const distanceLabelMilesRangeTextStyle: TextCustomProps = {
  ...distanceLabelMilesTextStyle,
  style: {...distanceLabelMilesTextStyle, fontSize: TextSize.TextSize12},
};

export const dealerNameTextStyle: TextCustomProps = {
  appearance: TextAppearance.label100,
  tag: TextTag.span,
  style: {
    fontSize: TextSize.TextSize16,
    lineHeight: TextLineHeight.TextLineHeight20,
    fontWeight: TextWeight.regular,
    color: TextColor.inherit,
  },
};

export const dealerDistanceTextStyle: TextCustomProps = {
  ...dealerNameTextStyle,
  style: {...dealerNameTextStyle.style, fontSize: TextSize.TextSize10},
};

export const getDealerLabel = (
  dealer?: {name?: string; distance?: number} | null,
  milesDistance?: string,
) => {
  return (
    <div className="location-dealer-label">
      <TextCustom {...dealerNameTextStyle}>
        <span className="notranslate">{dealer?.name}</span>{' '}
        <TextCustom {...dealerDistanceTextStyle}>
          {`${dealer?.distance?.toFixed(2)} ${milesDistance}`}
        </TextCustom>
      </TextCustom>
    </div>
  );
};
